<div class="form-modal">
    <div class="form-modal__body">

        <a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
            aria-label="Close organization edit form">
            <img src="./assets/img/icons-svg/close-icon.svg">
        </a>
        <div class="img-wrapper">
            <div class="clearfix"></div>
            <div class="title-wrapper">
                <h1>Create config</h1>
            </div>
        </div>
        <popup-loader *ngIf="isloaded"></popup-loader>
        <div class="form-wrapper">
            <form novalidate [formGroup]="configCreateForm" (ngSubmit)="doSave()">
                <tags-autocomplete label="Section" placeholder="Add new section" [allTags]="section"
                    formControlName="Section">
                </tags-autocomplete>
                <div class="error-message" *ngIf="isSubmitted && configCreateForm.value.Section.length === 0">
                    Section is required
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="language">Language</label>
                    <input class="app-c-form-control" type="text" id="language" formControlName="Language" />
                </div>
                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="setting">Setting</label>
                    <input class="app-c-form-control" type="text" id="setting" formControlName="Setting" />
                    <div class="error-message" *ngIf="isSubmitted && configCreateForm.get('Setting').hasError('required')">
                        Setting is required
                    </div>
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="key">Key</label>
                    <input class="app-c-form-control" type="text" id="key" formControlName="Key" />
                    <div class="error-message" *ngIf="isSubmitted && configCreateForm.get('Key').hasError('required')">
                        Key is required
                    </div>
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="value">Value</label>
                    <input class="app-c-form-control" type="text" id="value" formControlName="Value" />
                    <div class="error-message" *ngIf="isSubmitted && configCreateForm.get('Value').hasError('required')">
                        Value is required
                    </div>
                </div>

                <div class="fixed-footer">
                    <button tabindex="0" class="btn-primary btn">
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
